module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$store.state.user.id_rol !== 5 ? _vm.$t('entity.title') : 'Entidad'))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [(_vm.$store.state.user.id_rol !== 5) ? _c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['entidades:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'entidad', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['entidades:update'] && _vm.$store.state.user.id_rol == 1) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.regenerar(items.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("vpn_key")])], 1), _vm._v(" "), _c('span', [_vm._v("Generar Token de acceso")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['entidades:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'entidad')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['entidades:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.idEntidad != items.item.id) ? _c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'entidad', 'EditEntidad')
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.permissions['entidades:update'] && _vm.idEntidad != items.item.id) ? _c('v-icon', {
          attrs: {
            "color": items.item.active === 'ACTIVE' ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.idEntidad == items.item.id) ? _c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("business")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Esta es mi entidad.")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.sigla))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.web))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.direccion))]), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }], null, false, 56077139)
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['entidades:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.descargarTodo()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v(" Sincronizar\n            ")], 1), _vm._v(" "), _c('span', [_vm._v("Sincronizar con el Portal Único de Trámites")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['entidades:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')) + "\n            ")], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('entity.add')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-icon', [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('entity.crud.editEnt') : _vm.$t('entity.crud.addEnt')) + "\n            ")], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [(_vm.form.estado == 'ACTIVO') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": "success",
      "text-color": "white"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.estado) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.form.estado == 'INACTIVO') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": "warning",
      "text-color": "white"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.estado) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('h4', [_vm._v("Datos generales")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nombre",
      "label": _vm.$t('entity.crud.name'),
      "id": "nombre",
      "autofocus": "",
      "maxlength": "150",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.nombre),
      callback: function($$v) {
        _vm.$set(_vm.form, "nombre", $$v)
      },
      expression: "form.nombre"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "sigla",
      "label": _vm.$t('entity.crud.acronym'),
      "id": "sigla",
      "maxlength": "20"
    },
    model: {
      value: (_vm.form.sigla),
      callback: function($$v) {
        _vm.$set(_vm.form, "sigla", $$v)
      },
      expression: "form.sigla"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "descripcion",
      "label": _vm.$t('entity.crud.description'),
      "id": "descripcion",
      "maxlength": "500",
      "counter": 500,
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.form, "descripcion", $$v)
      },
      expression: "form.descripcion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "codigo_portal",
      "label": "Código único de portal",
      "id": "codigo_portal",
      "maxlength": "20",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.codigo_portal),
      callback: function($$v) {
        _vm.$set(_vm.form, "codigo_portal", $$v)
      },
      expression: "form.codigo_portal"
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("Datos de contacto")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": _vm.$t('entity.crud.email'),
      "prepend-icon": "email",
      "id": "email",
      "maxlength": "100",
      "rules": _vm.$validate(['email'])
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "web",
      "label": _vm.$t('entity.crud.web'),
      "prepend-icon": "public",
      "id": "web",
      "maxlength": "100",
      "rules": _vm.$validate(['url'])
    },
    model: {
      value: (_vm.form.web),
      callback: function($$v) {
        _vm.$set(_vm.form, "web", $$v)
      },
      expression: "form.web"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "direccion",
      "label": _vm.$t('entity.crud.address'),
      "id": "direccion",
      "maxlength": "500",
      "counter": 500
    },
    model: {
      value: (_vm.form.direccion),
      callback: function($$v) {
        _vm.$set(_vm.form, "direccion", $$v)
      },
      expression: "form.direccion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('entity.crud.phones'),
      "chips": "",
      "tags": "",
      "prepend-icon": "phone"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "close": "",
            "selected": data.selected
          },
          on: {
            "input": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(data.item) + "\n                      ")])]
      }
    }], null, false, 490438845),
    model: {
      value: (_vm.form.telefonos),
      callback: function($$v) {
        _vm.$set(_vm.form, "telefonos", $$v)
      },
      expression: "form.telefonos"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal');
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')) + "\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')) + "\n              ")], 1)], 1)], 1)], 1)], 2) : _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('h4', [_vm._v("Datos generales")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nombre",
      "label": _vm.$t('entity.crud.name'),
      "id": "nombre",
      "autofocus": "",
      "maxlength": "150",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.nombre),
      callback: function($$v) {
        _vm.$set(_vm.form, "nombre", $$v)
      },
      expression: "form.nombre"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "sigla",
      "label": _vm.$t('entity.crud.acronym'),
      "id": "sigla",
      "maxlength": "20"
    },
    model: {
      value: (_vm.form.sigla),
      callback: function($$v) {
        _vm.$set(_vm.form, "sigla", $$v)
      },
      expression: "form.sigla"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "descripcion",
      "label": _vm.$t('entity.crud.description'),
      "id": "descripcion",
      "maxlength": "500",
      "counter": 500,
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.form, "descripcion", $$v)
      },
      expression: "form.descripcion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "codigo_portal",
      "label": "Código único de portal",
      "id": "codigo_portal",
      "maxlength": "20",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.codigo_portal),
      callback: function($$v) {
        _vm.$set(_vm.form, "codigo_portal", $$v)
      },
      expression: "form.codigo_portal"
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("Datos de contacto")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": _vm.$t('entity.crud.email'),
      "prepend-icon": "email",
      "id": "email",
      "maxlength": "100",
      "rules": _vm.$validate(['email'])
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "web",
      "label": _vm.$t('entity.crud.web'),
      "prepend-icon": "public",
      "id": "web",
      "maxlength": "100",
      "rules": _vm.$validate(['url'])
    },
    model: {
      value: (_vm.form.web),
      callback: function($$v) {
        _vm.$set(_vm.form, "web", $$v)
      },
      expression: "form.web"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "direccion",
      "label": _vm.$t('entity.crud.address'),
      "id": "direccion",
      "maxlength": "500",
      "counter": 500
    },
    model: {
      value: (_vm.form.direccion),
      callback: function($$v) {
        _vm.$set(_vm.form, "direccion", $$v)
      },
      expression: "form.direccion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('entity.crud.phones'),
      "chips": "",
      "tags": "",
      "prepend-icon": "phone"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "close": "",
            "selected": data.selected
          },
          on: {
            "input": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(data.item) + "\n                  ")])]
      }
    }]),
    model: {
      value: (_vm.form.telefonos),
      callback: function($$v) {
        _vm.$set(_vm.form, "telefonos", $$v)
      },
      expression: "form.telefonos"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Guardar cambios\n          ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("vpn_key")]), _vm._v(" Token de acceso - " + _vm._s(_vm.nombre) + "\n        "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 2)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Token de la entidad",
      "textarea": "",
      "readonly": "",
      "rows": "14"
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 2)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Cerrar\n        ")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98577350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eApostilla/entidad/Entidad.vue
// module id = 534
// module chunks = 2